import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {Demokratiewerkstatt} from "../../../models/demokratiewerkstatt.model";
import {DemokratiewerkstattService} from "../../../services/demokratiewerkstatt.service";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";

@Component({
  selector: 'app-demokratiewerkstatt-list',
  templateUrl: './demokratiewerkstatt-list.component.html',
  styleUrls: ['./demokratiewerkstatt-list.component.css']
})
export class DemokratiewerkstattListComponent implements OnInit, OnDestroy {
  public showSpinner: boolean = true;

  public demokratiewerkstatt: Demokratiewerkstatt[] = [];
  public demokratiewerkstattSubscription: Subscription;
  public categorySubscription: Subscription;
  public categories: any = [];

  public displayedColumns: string[] = ['position', 'title', 'content', 'created_at', 'edit', 'delete'];
  public dataSource: MatTableDataSource<Demokratiewerkstatt>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private readonly _workShortService: DemokratiewerkstattService,
    private readonly _categoryService: DemokratiewerkstattCategoryService) {
  }

  ngOnInit(): void {

    this._categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription = this._categoryService.DemokratiewerkstattCategorySubject
      .subscribe(
        (response: any) => {
          this.categories = response;
        },
        (error) => {
          console.log("An Error occured: " + error);
        }
      )


    this._workShortService.getWorkshops();
    this.demokratiewerkstattSubscription = this._workShortService.demokratiewerkstatt$.subscribe(
      (response: Demokratiewerkstatt[]) => {
        this.demokratiewerkstatt = response;
        this.demokratiewerkstatt = [...this.demokratiewerkstatt.map(x => JSON.parse(JSON.stringify(x)))];
        this.demokratiewerkstatt = this.demokratiewerkstatt.map(demokratiewerkstatt => {
          let subDes = demokratiewerkstatt.content.replace(/<(.+?)>/g, '');
          if (subDes.length > 40) {
            subDes = subDes.substring(0, 40);
            subDes = subDes.substring(0, subDes.lastIndexOf(' '));
            subDes += '...';
          }
          demokratiewerkstatt.content = subDes;
          return demokratiewerkstatt;
        });
        this.showSpinner = false;

        this.dataSource = new MatTableDataSource(this.demokratiewerkstatt);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        console.log('An error occured: ' + error);
      }
    );
  }

  public applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public deleteProject(demokratiewerkstatt: Demokratiewerkstatt): void {
    this._workShortService.deleteProject(demokratiewerkstatt.id ?? 0).subscribe(
      (response):void => {
        console.log(response);
        this._workShortService.emitDemokratiewerkstattSubject();
        this.ngOnInit();
      }
    );
  }

  ngOnDestroy(): void {
    this.demokratiewerkstattSubscription.unsubscribe();
  }

}
